import React from "react";
import { buttonVariants, buttonDisabledStyle } from "../../styles/buttonStyles";
import { useTranslation } from "react-i18next";

interface SubmitButtonProps {
  onClick: () => void;
  disabled?: boolean;
  children?: React.ReactNode;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ 
  onClick, 
  disabled = false,
  children 
}) => {
  const { t } = useTranslation('dataProcessing');
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`${buttonVariants.submit} ${disabled ? buttonDisabledStyle : ''}`}
    >
      {children || t('submitButton')}
    </button>
  );
};

export default SubmitButton;